/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calibration_Accounts_For_Radiator_HeatInputs */



/**
* | output |
* | --- |
* | "The calibration allows the th. head to take into account the heat emitted by the radiator" |
*
* @param {Calibration_Accounts_For_Radiator_HeatInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_accounts_for_radiator_heat = /** @type {((inputs?: Calibration_Accounts_For_Radiator_HeatInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Accounts_For_Radiator_HeatInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The calibration allows the th. head to take into account the heat emitted by the radiator")
	return /** @type {LocalizedString} */ ("Le calibrage permet à la tête th. de prendre en compte la chaleur émise par le radiateur")
});